// TODO: Move this to CarouselContainer if no other container is needed.

import { store, getContext, getElement } from '@wordpress/interactivity';
import { merge } from 'object-deep-merge';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const updatePagination = (swiper) => {
  if (swiper.params.slidesPerView >= swiper.slides.length) {
    // console.debug(`[gridibleCarousel] Disabling pagination because slidesPerView >= slides.length`);
    swiper.pagination.disable();
  } else {
    // console.debug(`[gridibleCarousel] Enabling pagination because slidesPerView < slides.length`);
    swiper.pagination.enable();
  }
};

const { state, actions } = store("gridibleCarousel", {
  state: {
  },

  actions: {
  },

  callbacks: {
    init: () => {
      const context = getContext();
      // console.log(`[gridibleCarousel.init] context:`, context)
      const { ref } = getElement();

      // Ensure we have valid children below our root element. If not, 
      // Swiper will throw an error.

      // First, check for the swiper wrapper.
      const swiperWrapper = ref.querySelector('.swiper-wrapper');
      if (!swiperWrapper) {
        console.warn(`[gridibleCarousel.init] No swiper-wrapper found. Swiper will not be initialized.`);
        return;
      }

      // Next, check for the swiper slides.
      const swiperSlides = swiperWrapper.querySelectorAll('.swiper-slide');
      if (swiperSlides.length === 0) {
        console.warn(`[gridibleCarousel.init] No swiper slides found. Swiper will not be initialized.`);
        return;
      }

      const liveSwiperConfig = {
        // Enable modules
        modules: [Autoplay, Navigation, Pagination],

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        
        // On init and resize, update the pagination state. This helps to avoid
        // pagination controls appearing when the number of slides is not 
        // greater than the number of slides per view.
        /*
          Note that this pagination update was only necessary for issues that
          arose in The Onion. I couldn't reproduce the issue in Gridible's own
          test bed. These listeners may have performance implications, and may
          need to be revisited in the future.
        */
        on: {
          init: function () { updatePagination(this); },
          resize: function () { updatePagination(this); },
        }
      };
      
      const deProxiedSwiperConfig = JSON.parse(JSON.stringify(context.swiperConfig));
      const swiperConfig = merge(deProxiedSwiperConfig, liveSwiperConfig);
      
      // Always start disabled. We'll enable the swiper after a timeout.
      swiperConfig.enabled = false;

      const hasAutoplay = typeof swiperConfig.autoplay === 'object' && Number.isInteger(swiperConfig.autoplay.delay);
      
      const swiper = new Swiper(ref, swiperConfig);

      /*
        Initialize enable Swiper after is has initialized. This prevents weird
        bugs in the autoplay speed that occur when Swiper is enabled and 
        autoplay is set to immediately begin.
      */
      setTimeout(() => {
        console.log(`[gridibleCarousel.init] Enabling swiper`);
        swiper.enable();
        if (hasAutoplay) {
          swiper.autoplay.start();
        }
      }, 250);
    },
  },
});
